import { render, staticRenderFns } from "./quotation-form.vue?vue&type=template&id=1b337367"
import script from "./quotation-form.vue?vue&type=script&lang=js"
export * from "./quotation-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports